module.exports = __webpack_public_path__ + "img/vintage@2x.ec16f3e.webp";